import React, { Component } from 'react';

class MaintenanceMonitor extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="MaintenanceMonitorPage">
        MaintenanceMonitor
      </div>
    );

  };

};

export default MaintenanceMonitor;


// WEBPACK FOOTER //
// ./src/components/content/maintenanceMonitor/maintenanceMonitor.js